module.exports = __webpack_public_path__ + "images/emoji/koala.5b4f2ed836d6fb395dd7.png";